/**
 * Empty state component for team list.
 * Shows friendly illustration and invite CTA when no team members exist.
 */

import { useTranslation } from 'react-i18next';

interface TeamEmptyStateProps {
  onInvite: () => void;
}

export default function TeamEmptyState({ onInvite }: TeamEmptyStateProps) {
  const { t } = useTranslation('team');

  return (
    <div className="bg-white rounded-lg shadow-sm p-12 text-center">
      {/* Illustration - team icon */}
      <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
        <i className="ri-team-line text-4xl text-blue-500" />
      </div>

      {/* Heading */}
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        {t('buildYourTeam', 'Build your team')}
      </h3>

      {/* Description */}
      <p className="text-gray-500 mb-6 max-w-sm mx-auto">
        {t('buildYourTeamDesc', 'Invite colleagues to help manage your properties')}
      </p>

      {/* CTA Button */}
      <button
        onClick={onInvite}
        className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
      >
        <i className="ri-user-add-line" />
        {t('inviteMember', 'Invite Member')}
      </button>
    </div>
  );
}
